import Icon from "../../components/Icon"

const TONES = {
  rose: "border-rose-200 bg-rose-50 text-rose-800",
  slate: "border-slate-200 bg-slate-50 text-slate-700",
}

// The objection line under a bill: who has to act now, and the customer's own
// words. `note` comes from billObjectionDisplay.
function BillObjectionNote({ note, compact = false }) {
  if (!note) return null
  return (
    <div
      className={`mt-1.5 rounded-lg border px-2 py-1.5 text-left ${TONES[note.tone] || TONES.slate} ${
        compact ? "text-[10px]" : "text-[11px]"
      }`}
    >
      <p className="flex items-start gap-1 font-semibold leading-snug">
        <Icon name="flag-fill" size="0.6rem" className="mt-0.5 shrink-0" />
        <span>{note.title}</span>
      </p>
      {note.message && <p className="mt-0.5 break-words italic leading-snug">“{note.message}”</p>}
    </div>
  )
}

export default BillObjectionNote
